<template>
    <b-card no-body>
        <template #header>
            <div class="d-flex">
                <strong class="pt-1">
                    Audit Logs
                </strong>
                <span class="ms-auto">
                    <b-button style="padding-top: 2px; padding-bottom: 2px;" @click="exportToExcel()" size="sm" variant="primary">
                        <i class="fas fa-file-excel me-1"></i>
                        Export to Excel
                    </b-button>
                </span>
            </div>
        </template>

        <div class="p-1">
            <webix-ui :config="ui" v-model="log_data"></webix-ui>
            <div style="width: 100%; height: 100%;" id="auditLogsPager"></div>
        </div>
    </b-card>
</template>

<script>
import { clientAdminState, clientAdminMethods } from '@/state/helpers'
import { uniqueId, cloneDeep } from 'lodash';
export default {
    data:() => ({
        has_mounted: false,
    }),
    components:{
    },
    computed:{
        ...clientAdminState,
        log_data(){
            if(this.audit_logs){
                return cloneDeep(this.audit_logs);
            }
            else{
                return [];
            }
        },
        ui(){
            //let el = this;
            let config = {
                view: 'datatable',
                id: 'auditLog',
                css:"webix_data_border webix_header_border",
                hover: 'row-hover',
                autoheight: true,
                fillspace: true,
                editable: true,
                columns:[
                    { id:"type", header:[ "Action",{content:"textFilter"}], width: 450},
                    { id:"user_name", header:[ "User Name",{content:"textFilter"}], sort:"string", width: 180},
                    { id:"user_email", header:[ "User Email",{content:"textFilter"}], sort:"string", width: 180},
                    { id:"ip_address", header:[ "IP Address",{content:"textFilter"}], sort:"string", width: 180},
                    { id:"created_at", header:[ "Time",{content:"textFilter"}], sort:"string", width: 180},
                ],
                pager:{
                    template:"{common.prev()} {common.pages()} {common.next()}",
                    container:"auditLogsPager",
                    size:15,
                    group:5
                },
            }
            return config;
        },
    },
    methods:{
        ...clientAdminMethods,
        exportToExcel(){
            window.webix.toExcel(window.webix.$$("auditLog"), {
                filename: uniqueId("auditlog_"), // for filename
                name: "Audit Log" // for sheet name
            });
        }
    },
    mounted(){
        this.loadAuditLogs();
    },
}
</script>

<style>

</style>